"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elk = void 0;
exports.elk = {
    router: '0xA63B831264183D755756ca9AE5190fF5183d65D6',
    factory: '0x31aFfd875e9f68cd6Cd12Cee8943566c9A4bBA13',
};
